// extracted by mini-css-extract-plugin
module.exports = {"Label":"styles_Label__j02Qw","Label--light":"styles_Label--light__31wFu"};